<template>
  <div class="question-card">
    <div class="question-card-header">
      <div>
        <h5 class="question-title">Question {{ index + 1 }}</h5>
        <p class="question-body mb-0">{{ question.question }}</p>
      </div>

      <div class="question-actions">
        <button type="button" class="btn btn-default btn-sm" @click="$emit('edit')">
          <i class="icon md-edit" aria-hidden="true"></i>
          Edit
        </button>
        <button
          type="button"
          class="btn btn-danger btn-sm"
          :disabled="disabled"
          @click="$emit('delete')"
        >
          <i class="icon md-delete" aria-hidden="true"></i>
          Delete
        </button>
      </div>
    </div>

    <div class="choices-grid">
      <div
        v-for="choice in choices"
        :key="choice.key"
        class="choice-card"
        :class="{ 'is-correct': isCorrect(choice.answer) }"
      >
        <div class="choice-label">{{ choice.label }}</div>
        <div class="choice-value">{{ choice.value || '-' }}</div>
      </div>
    </div>

    <div class="question-footer">
      <span class="bonus-time"
        >Extra time: {{ question.extra_time || 0 }} seconds</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "SpaceQuestionCard",

  props: {
    index: {
      type: Number,
      required: true,
    },
    question: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    choices() {
      return [
        {
          key: "choice1",
          label: "Choice 1",
          value: this.question.choice1,
          answer: 1,
        },
        {
          key: "choice2",
          label: "Choice 2",
          value: this.question.choice2,
          answer: 2,
        },
      ];
    },
  },

  methods: {
    isCorrect(answer) {
      return Number(this.question.correct_answer) === answer;
    },
  },
};
</script>

<style lang="scss" scoped>
.question-card {
  padding: 1rem;
  border: 1px solid #dfe4ea;
  border-radius: 12px;
  background: #fff;
}

.question-card-header {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
  justify-content: space-between;
}

.question-title {
  margin-bottom: 0.5rem;
}

.question-body {
  color: #526069;
}

.question-actions {
  gap: 0.5rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.choices-grid {
  gap: 1rem;
  display: grid;
  margin-top: 1rem;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.choice-card {
  padding: 0.875rem;
  border-radius: 10px;
  border: 1px solid #dfe4ea;
  background: #f8fafc;

  &.is-correct {
    border-color: #0b6b2b;
    box-shadow: inset 0 0 0 1px #0b6b2b;
    background: #eefaf2;
  }
}

.choice-label {
  margin-bottom: 0.35rem;
  color: #76838f;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
}

.choice-value {
  color: #37474f;
  word-break: break-word;
}

.question-footer {
  margin-top: 1rem;
}

.bonus-time {
  color: #526069;
  font-weight: 600;
}
</style>
